/**
 * U0 · `CPP → CQA` with the attribute's spec, shown and edited.
 *
 * A critical process parameter is only critical *because of* a quality attribute it controls.
 * Showing the parameter alone loses the reason, and the reason is what a reviewer checks.
 *
 * **The model cannot carry this yet.** `RecipeNode` has no CPP edge and `Operation_type` has
 * no controlled-attribute list, so this renders what it is given and says plainly when it is
 * given nothing. That is a contract request against U0 §3, not a licence to invent a field —
 * fabricating an edge here would put a criticality claim into a record on no evidence.
 */
import React from "react";
import { Tooltip } from "antd";

export default function CriticalityEdges({ edges, emptyNote }) {
  if (!edges?.length) {
    return emptyNote ? <span className="u0-cpp none">{emptyNote}</span> : null;
  }
  return (
    <span className="u0-cpps">
      {edges.map((e) => (
        <Tooltip
          key={`${e.parameter}-${e.attribute}`}
          title={
            e.spec
              ? `${e.attribute} — ${e.spec}`
              : `${e.attribute} · no specification recorded, so nothing states what "in range" means`
          }
        >
          <span className={`u0-cpp ${e.spec ? "" : "unspecified"}`}>
            {e.parameter} <i>→</i> {e.attribute}
          </span>
        </Tooltip>
      ))}
    </span>
  );
}
